import { Link } from 'react-router-dom';
const Navbar = () => {
  return (
    <nav class="navbar navbar-expand-lg bg-light">
      <div class="container-fluid">
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <Link class="nav-link" to='/'>Suche</Link>
            </li>
            <li class="nav-item">
              <Link class="nav-link" to='/prompt'>Audience Prompt</Link>
            </li>
            <li class="nav-item">
              <Link class="nav-link" to='/vector'>Audience Vector</Link>
            </li>
            <li class="nav-item">
              <Link class="nav-link" to='/raw'>Raw Prompt</Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
export default Navbar;
